import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import Settings from "./Settings";
import Auth from "./Auth";
import Common from "./Common";
import DisableButton from "./DisableButton";
import BankAccount from "./BankAccount";

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    auth: Auth,
    common: Common,
    button: DisableButton,
    bankAccount: BankAccount,
  });

export default createRootReducer;
